import { VehicleModelType } from '@orcar/common';

export const CAR_TYPE = [
  {
    id: VehicleModelType.COMPACT,
    label: '준중형',
  },
  {
    id: VehicleModelType.IMPORTED,
    label: '수입',
  },
  {
    id: VehicleModelType.URBAN,
    label: '경형',
  },
  {
    id: VehicleModelType.MIDSIZE,
    label: '중형',
  },
  {
    id: VehicleModelType.RV,
    label: '승합',
  },
  {
    id: VehicleModelType.CITY,
    label: '소형',
  },
  {
    id: VehicleModelType.LUXURY,
    label: '고급',
  },
  {
    id: VehicleModelType.SUV,
    label: 'SUV',
  },
  {
    id: VehicleModelType.EV,
    label: '전기차',
  },
  {
    id: VehicleModelType.SUPERCAR,
    label: '슈퍼카',
  },
];
